import { useState } from 'react';
import type { ReporteAbmWebEstado, ReporteAbmWebParams } from '@lib/services/reporteAbmWeb';
import {
  BotonBuscar,
  CampoTexto,
  FormFiltros,
  RangoFechas,
  SelectOrganizacion,
} from '@components/FiltrosReporte';

interface FiltrosProps {
  onBuscar: (params: ReporteAbmWebParams) => void;
  loading?: boolean;
}

export function ReporteAbmWebFiltros({ onBuscar, loading }: FiltrosProps) {
  const [estado, setEstado] = useState<ReporteAbmWebEstado | ''>('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [empresaId, setEmpresaId] = useState('');
  const [numero, setNumero] = useState('');
  const [dni, setDni] = useState('');

  function handleSubmit() {
    onBuscar({
      estado: estado || undefined,
      fechaDesde: fechaDesde || undefined,
      fechaHasta: fechaHasta || undefined,
      empresaId: empresaId || undefined,
      numero: numero || undefined,
      dni: dni || undefined,
    });
  }

  return (
    <FormFiltros onSubmit={handleSubmit}>
      <label className="formField" style={{ maxWidth: 120 }}>
        <span>Estado</span>
        <select
          className="input"
          value={estado}
          onChange={(e) => setEstado(e.target.value as ReporteAbmWebEstado | '')}
        >
          <option value="">— Todos —</option>
          <option value="alta">Activos</option>
          <option value="baja">Baja</option>
        </select>
      </label>

      <RangoFechas
        desde={fechaDesde}
        hasta={fechaHasta}
        onDesde={setFechaDesde}
        onHasta={setFechaHasta}
      />
      <SelectOrganizacion value={empresaId} onChange={setEmpresaId} />
      <CampoTexto label="Legajo" value={numero} onChange={setNumero} />
      <CampoTexto label="DNI" value={dni} onChange={setDni} />
      <BotonBuscar loading={loading} />
    </FormFiltros>
  );
}
